import { tv } from "@/utils/tv.config";
import type { VariantProps } from "tailwind-variants";

const popOverClasses = tv({
  slots: {
    trigger: [
      "flex size-10 items-center justify-center rounded-md border border-gray-200 bg-gray-50 text-gray-900 select-none hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-blue-800 active:bg-gray-100 data-[popup-open]:bg-gray-100",
    ],
    popup: [
      "origin-[var(--transform-origin)] rounded-lg bg-[canvas] px-6 py-4 text-gray-900 shadow-lg  outline outline-1 outline-gray-200 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0",
    ],
    arrow: [
      "data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=left]:rotate-90 data-[side=right]:left-[-13px] data-[side=right]:-rotate-90 data-[side=top]:bottom-[-8px] data-[side=top]:rotate-180",
    ],
    title: ["text-base font-regular"],
    description: ["text-base text-gray-600"],
  },
  variants: {},
});

export const {
  trigger: popoverTriggerClasses,
  popup: popOverPopupClasses,
  arrow: popoverArrowClasses,
  title: popoverTitleClasses,
  description: popoverDescriptionClasses,
} = popOverClasses();

export type PopoverVariants = VariantProps<typeof popOverClasses>;
